import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=63a51501&scoped=true&lang=pug&"
import script from "./MainScreen.vue?vue&type=script&lang=js&"
export * from "./MainScreen.vue?vue&type=script&lang=js&"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=63a51501&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a51501",
  null
  
)

export default component.exports